/**
 * ViewportUtils keeps CSS variables in sync with the browser's visual viewport.
 * This helps on mobile browsers with hideable URL/tool bars where CSS vh units
 * and window.innerHeight may not reflect the visible area used by the page.
 */
export function initializeViewportCssVariables(): void {
    const update = () => {
        const root = document.documentElement;

        // Fallbacks for environments without VisualViewport API
        const visualViewport = window.visualViewport;

        const innerHeightPx = window.innerHeight;
        const visualHeightPx = visualViewport?.height ?? innerHeightPx;
        const visualOffsetTopPx = visualViewport?.offsetTop ?? 0;
        const visualOffsetLeftPx = visualViewport?.offsetLeft ?? 0;

        // 1% of the visual viewport height in pixels
        const appVh = visualHeightPx * 0.01;

        // Difference between layout viewport and visual viewport can be used as UI overlays height
        const bottomUiOverlayPx = Math.max(0, innerHeightPx - (visualOffsetTopPx + visualHeightPx));

        root.style.setProperty('--app-vh', `${appVh}px`);
        root.style.setProperty('--app-visual-viewport-height', `${visualHeightPx}px`);
        root.style.setProperty('--app-visual-viewport-offset-top', `${visualOffsetTopPx}px`);
        root.style.setProperty('--app-visual-viewport-offset-left', `${visualOffsetLeftPx}px`);
        root.style.setProperty('--app-bottom-ui-offset', `${bottomUiOverlayPx}px`);
    };

    update();

    // Update on resize/scroll/zoom changes of the visual viewport
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    window.visualViewport?.addEventListener('resize', update);
    window.visualViewport?.addEventListener('scroll', update);
}

export default { initializeViewportCssVariables };


